import React, { useContext } from 'react';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';

import './styles.scss';
const HeaderStroke = ({ name }) => {
  let estilo = {};

  const { tema } = useContext(ContextoListaApartamentos);

  estilo = {
    width: '100%',
    marginBottom: '24px',
    justifyContent: 'flex-end',
  };

  return (
    <div style={estilo} className='centralized-space-between headerStroke'>
      <h1
        style={{
          WebkitTextStrokeColor: tema.primaryColor,
        }}
        id='tittle'
      >
        {name}
      </h1>
    </div>
  );
};

export default HeaderStroke;
